function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.696,
    height: 63.731,
    viewBox: "0 0 57.696 63.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10759"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10757"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1955",
    transform: "translate(1.75 7.603)",
    style: {
      stroke: "#343953",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    },
    d: "M0 0h41.098v47.748H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7452",
    d: "M491.352 471.276a4.41 4.41 0 1 0-8.82 0h-4.547a2.56 2.56 0 0 0-2.56 2.56v3.979h23.519v-3.979a2.56 2.56 0 0 0-2.56-2.56z",
    style: {
      fill: "#3d55dc"
    },
    transform: "translate(-464.885 -466.866)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 195",
    transform: "translate(10.54 20.217)",
    style: {
      stroke: "#727272",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    },
    d: "M0 0h23.609"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 196",
    transform: "translate(10.54 28.116)",
    style: {
      stroke: "#727272",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    },
    d: "M0 0h23.609"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 197",
    transform: "translate(10.54 36.015)",
    style: {
      stroke: "#727272",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    },
    d: "M0 0h23.609"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10758",
    transform: "translate(-464.885 -466.866)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 268",
    cx: 11.284,
    cy: 11.284,
    r: 11.284,
    transform: "rotate(-13.282 2432.018 -1873.295)",
    style: {
      fill: "#3d55dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7453",
    d: "M506.545 522.857h-.091a1.057 1.057 0 0 1-.811-.5l-3.483-5.675a1.058 1.058 0 0 1 1.8-1.107l2.734 4.455 7.462-8.479a1.058 1.058 0 1 1 1.588 1.4l-8.408 9.554a1.056 1.056 0 0 1-.791.352z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsult);
export default __webpack_public_path__ + "static/media/consult.2edc695d.svg";
export { ForwardRef as ReactComponent };